export const initSearch = (): void => {
  const initialUrl = new URL(window.location.href);
  const initialSearchParams = initialUrl.searchParams;

  const openSearchWithoutHistory = (): void => {
    $('#search-overlay, #search-burger-icon, #search-burger, .main-content, #footer').addClass(
      'is-active is-active-search',
    );
  };

  const openSearch = (): boolean => {
    openSearchWithoutHistory();

    const newURL = new URL(window.location.href);
    newURL.hash = '#search';
    window.history.pushState(window.history.state, '', newURL.href);

    return false;
  };

  const closeSearchWithoutHistory = (): void => {
    $('#search-overlay, #search-burger-icon, #search-burger, .main-content, #footer').removeClass(
      'is-active is-active-search is-active-after-reload',
    );
  };

  const closeSearch = (): boolean => {
    closeSearchWithoutHistory();

    const newURL = new URL(window.location.href);
    newURL.searchParams.delete('search');
    if (newURL.hash === '#search') {
      newURL.hash = '';
    }
    window.history.pushState(window.history.state, '', newURL.href);

    return false;
  };

  if (initialUrl.hash === '#search') {
    openSearch();
  }

  if (initialSearchParams.has('search')) {
    openSearchWithoutHistory();
  } else if (initialSearchParams.has('q')) {
    openSearchWithoutHistory();
  }

  window.addEventListener('popstate', () => {
    const newUrl = new URL(window.location.href);
    const searchParams = newUrl.searchParams;
    if (searchParams.has('search') || newUrl.hash === '#search' || searchParams.has('q')) {
      openSearchWithoutHistory();
    } else {
      closeSearchWithoutHistory();
    }
  });

  $('.open-search').on('click', openSearch);

  $('.close-search').on('click', closeSearch);

  document.onkeydown = (event): void => {
    if (event.key === 'Escape') {
      closeSearch();
    }
  };
};
